import { Injectable, Inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { Http, Headers, Response, RequestOptionsArgs } from '@angular/http';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { UmrCookieService } from '../common/services/umr-cookie.service';
import { CookieOptionsArgs } from 'angular2-cookie/core';
import { cloneRoutes, removeUnauthorizeRoutes } from './helpers/route-config.helper';
import { AuthInfo } from './authInfo';
import { activateAutoLogout, deActivateAutoLogout } from './helpers/auto-logout.helper';
import { getToken, getTokenFromRefreshToken, revokeToken } from './helpers/http-client.helper';
import { authCookieKey, allPermissions } from './constants/auth-keys';
import { Store } from '@ngrx/store';
import { AppState } from '../stores/index-store';
import { CLEAR_ALL_STORES_STATE } from '../stores/index-store.constants';
import { resourceServerUrl, currentUserMenuValue, currentUserRole } from './constants/auth-keys';

@Injectable()
export class AuthService {
    private currentUserMenuValueUrl: string = `${resourceServerUrl}/menu_value`;
    private currentUserRoleURI: string = `${resourceServerUrl}/role`;
    public redirectUrl: string;
    public logoutMessage: string;

    constructor(private store: Store<AppState>, private http: Http, private httpClient: HttpClient, private umrCookieService: UmrCookieService, private router: Router) { }

    get isLoggedIn(): boolean {
        let tokenInfo = this.getTokenInfo();
        return (typeof tokenInfo !== 'undefined' && tokenInfo !== null && typeof tokenInfo.access_token !== 'undefined' && typeof tokenInfo.refresh_token !== 'undefined');
    }

    private getTokenInfo() {
        return <AuthInfo>this.umrCookieService.getDeserializedObject(authCookieKey);
    }

    public get accessToken() {
        const accessTokenInfo = <AuthInfo>this.umrCookieService.getDeserializedObject(authCookieKey);
        return accessTokenInfo && accessTokenInfo.access_token;
    }

    public get refreshToken() {
        const accessTokenInfo = <AuthInfo>this.umrCookieService.getDeserializedObject(authCookieKey);
        return accessTokenInfo && accessTokenInfo.refresh_token;
    }

    private get refreshTokenLifeTime() {
        const accessTokenInfo = <AuthInfo>this.umrCookieService.getDeserializedObject(authCookieKey);
        return (accessTokenInfo && accessTokenInfo.refresh_expires) ? accessTokenInfo.refresh_expires : 0;
    }

    private get loginTime() {
        const accessTokenInfo = <AuthInfo>this.umrCookieService.getDeserializedObject(authCookieKey);
        return (accessTokenInfo && accessTokenInfo.created) ? accessTokenInfo.created : 0;
    }

    getCurrentUserMenuValue(): Observable<HttpResponse<any>> {
        return this.httpClient.get(this.currentUserMenuValueUrl, { observe: 'response' });
    }

    getCurrentUserRole(): Observable<HttpResponse<any>> {
        return this.httpClient.get(this.currentUserRoleURI, { observe: 'response' });
    }

    login(userID: string, password: string, acr: string): Observable<any> {
        return getToken(this.http, userID, password, acr)
            .map((value, index) => {
                this.saveAuthInfo(value, true);
                Observable.forkJoin(
                    this.getCurrentUserMenuValue(),
                    this.getCurrentUserRole()
                ).subscribe(data => {
                    if (data[0].status === 200) {
                        localStorage.setItem(currentUserMenuValue, data[0].body);
                    }
                    if (data[1].status === 200) {
                        localStorage.setItem(currentUserRole, data[1].body);
                    }
                },
                    err => { },
                  () => {
                    //console.log('Complete');
                    //console.log(this.redirectUrl);
                      if (this.redirectUrl && !this.redirectUrl.includes('/login')) {
                        this.router.navigateByUrl(this.redirectUrl);
                        this.redirectUrl = null;
                      }
                      else if (this.redirectUrl && this.redirectUrl.includes('/login')) {
                        this.router.navigate(['/']);
                      }
                      else {
                        this.router.navigate(['/']);
                      }
                    });
            });
    }

    renewToken(refreshToken): Observable<any> {
        return getTokenFromRefreshToken(this.http, refreshToken)
            .map((value, index) => {
                this.saveAuthInfo(value);
            });
    }

    logout() {
        this.store.dispatch({ type: CLEAR_ALL_STORES_STATE });
        localStorage.removeItem(currentUserMenuValue);
        localStorage.removeItem(currentUserRole);
        const tokenInfo = this.getTokenInfo();
        if (tokenInfo && tokenInfo.refresh_token) {
            const refreshToken = tokenInfo.refresh_token;
            this.umrCookieService.removeAllCookies();
            revokeToken(this.http, refreshToken).subscribe(_ => this.logoutNavigate(), err => this.logoutNavigate());
        }
        else {
            this.umrCookieService.removeAllCookies();
            this.logoutNavigate();
        }
    }

    logoutNavigate() {
        this.router.navigate(['/login']).then(isNavigated => {
            if (isNavigated) {

            }
        });
    }

    private saveAuthInfo(value, isAccessToken: boolean = false) {
        const info = <AuthInfo>value.json();
        info.created = (new Date()).valueOf();
        this.umrCookieService.setSerializedObject(authCookieKey, info);
        if (!this.isLoggedIn) {
            this.logoutMessage = 'Your browser does not accept cookies. cookies are required to use this site';
            this.logout();
        }
    }
}
